import { Button } from "@progress/kendo-react-buttons";
import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { OrderServiceExceptionViewModel } from "TypeGen/ServiceExceptions/order-service-exception-view-model";
import { ILink } from "types/link";
import { dateFormatter } from "utils/utils";

type Props = {
  resolve: (link: ILink) => void;
} & GridCustomCellProps;

export const ResolvedCell = (props: Props) => {
  const data = props.dataItem as OrderServiceExceptionViewModel;
  const resolveLink = data.Links.find(l => l.Name === "Resolve");

  const handleResolve = () => {
    if (resolveLink) {
      props.resolve(resolveLink);
    }
  };

  return <td {...props.tdProps}>
    {resolveLink ? <Button size="small" fillMode="flat" themeColor="success" onClick={handleResolve}>Resolve</Button>
    : data.ResolvedByFullName ? <>
      {data.ResolvedByFullName}<br />
      {dateFormatter(data.ResolvedDateTime)}
    </> : null}
  </td>
}